(jQuery.cookie = function (e, t, i) {
  if (void 0 !== t) {
    (i = i || {}), null === t && ((t = ""), (i.expires = -1));
    var o,
      n = "";
    i.expires &&
      ("number" == typeof i.expires || i.expires.toUTCString) &&
      ("number" == typeof i.expires
        ? (o = new Date()).setTime(o.getTime() + 864e5 * i.expires)
        : (o = i.expires),
      (n = "; expires=" + o.toUTCString()));
    var r = i.path ? "; path=" + i.path : "",
      s = i.domain ? "; domain=" + i.domain : "",
      a = i.secure ? "; secure" : "";
    document.cookie = [e, "=", encodeURIComponent(t), n, r, s, a].join("");
  } else {
    var l = null;
    if (document.cookie && "" != document.cookie)
      for (var c = document.cookie.split(";"), d = 0; d < c.length; d++) {
        var p = jQuery.trim(c[d]);
        if (p.substring(0, e.length + 1) == e + "=") {
          l = decodeURIComponent(p.substring(e.length + 1));
          break;
        }
      }
    return l;
  }
}),
  (Shopify.Products = (function () {
    var e = {
        howManyToShow: 3,
        howManyToStoreInMemory: 10,
        wrapperId: "recently-viewed-products",
        templateId: "recently-viewed-product-template",
        layout: "slider",
        swipe: !0,
        media: "adapt",
        onComplete: null,
      },
      t = [],
      i = null,
      o = null,
      n = 0,
      r = {
        configuration: {
          expires: 90,
          path: "/",
          domain: window.location.hostname,
        },
        name: "shopify_recently_viewed",
        write: function (e) {
          jQuery.cookie(this.name, e.join(" "), this.configuration);
        },
        read: function () {
          var e = [],
            t = jQuery.cookie(this.name);
          return null !== t && (e = t.split(" ")), e;
        },
        destroy: function () {
          jQuery.cookie(this.name, null, this.configuration);
        },
        remove: function (e) {
          var t = this.read(),
            i = jQuery.inArray(e, t);
          -1 !== i && (t.splice(i, 1), this.write(t));
        },
      },
      s = function () {
        if (
          (i.find(".item").length <= 2 &&
            $("#recently-viewed-products-list").addClass("center"),
          i.show(),
          e.onComplete)
        )
          try {
            e.onComplete();
          } catch (t) {}
      },
      a = function () {
        if (t.length && n < e.howManyToShow) {
          var o =
            window.routes.root +
            "/products/" +
            t[0] +
            "?view=ajax_recently_viewed";
          jQuery.ajax({
            type: "get",
            url: o,
            cache: !1,
            success: function (e) {
              i.append(e), t.shift(), n++, a();
            },
            error: function () {
              r.remove(t[0]), t.shift(), a();
            },
          });
        } else s();
      },
      l = function () {
        if (t.length) {
          var o = window.routes.root + "/collections/all";
          $.ajax({
            type: "get",
            url: o,
            cache: !1,
            data: {
              view: "ajax_recently_viewed",
              constraint:
                `limit=${t.length}+layout=${e.layout}+imageRatio=${e.media}+swipe=${e.swipe}+sectionId=recently-viewed+list_handle=` +
                encodeURIComponent(t),
            },
            beforeSend: function () {},
            success: function (e) {
              let t = $(".halo-recently-viewed-block .recentlyViewed-row");
              t.empty(), i.append(e);
            },
            error: function (e, t) {
              alert($.parseJSON(e.responseText).description);
            },
            complete: function () {
              if ("slider" == e.layout) {
                var t = $(".halo-recently-viewed-block").find(
                    ".products-carousel"
                  ),
                  i = t.data("item-to-show"),
                  o = t.data("item-dots"),
                  n = t.data("item-arrows"),
                  ba = t.data("half-item");
                  console.log(ba)
                t.length > 0 &&
                  t.not(".slick-initialized") &&
                  t.slick({
                    mobileFirst: !0,
                    adaptiveHeight: !0,
                    vertical: !1,
                    infinite: !1,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: !1,
                    dots: !0,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    responsive: [
                      {
                        breakpoint: 1599,
                        settings: {
                          arrows: n,
                          dots: o,
                          get slidesToShow() {
                            if (null != i && "" !== i)
                              return (this.slidesToShow = i);
                            return (this.slidesToShow = 1);
                          },
                        },
                      },
                      {
                        breakpoint: 1024,
                        settings: {
                          arrows: n,
                          dots: o,
                          get slidesToShow() {
                            if (null == i || "" === i)
                              return (this.slidesToShow = 1);
                            if (5 == i) return (this.slidesToShow = i - 1);
                            return (this.slidesToShow = i);
                          },
                        },
                      },
                      {
                        breakpoint: 991,
                        settings: { slidesToShow: 4, slidesToScroll: 1 },
                      },
                      {
                        breakpoint: 767,
                        settings: { slidesToShow: 3, slidesToScroll: 1 },
                      },
                      {
                        breakpoint: 320,
                        settings: { slidesToShow: 2, slidesToScroll: 1 },
                      },
                    ],
                  });
              }
            },
          });
        }
      };
    return {
      resizeImage: function (e, t) {
        if (null == t) return e;
        if ("master" == t) return e.replace(/http(s)?:/, "");
        var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
        if (null == i) return null;
        var o = e.split(i[0]),
          n = i[0];
        return (o[0] + "_" + t + n).replace(/http(s)?:/, "");
      },
      showRecentlyViewed: function (n) {
        var n = n || {};
        jQuery.extend(e, n),
          (t = r.read()),
          (o = e.templateId),
          (i = jQuery("#" + e.wrapperId)),
          (e.howManyToShow = Math.min(t.length, e.howManyToShow)),
          e.howManyToShow &&
            i.length &&
            ("recently-viewed-product-popup" == o ? a() : l());
      },
      getConfig: function () {
        return e;
      },
      clearList: function () {
        r.destroy();
      },
      recordRecentlyViewed: function (t) {
        var t = t || {};
        jQuery.extend(e, t);
        var i = r.read();
        if (-1 !== window.location.pathname.indexOf("/products/")) {
          var o = window.location.pathname.match(
              /\/products\/([a-z0-9\-]+)/
            )[1],
            n = jQuery.inArray(o, i);
          -1 === n
            ? (i.unshift(o), (i = i.splice(0, e.howManyToStoreInMemory)))
            : (i.splice(n, 1), i.unshift(o)),
            r.write(i);
        }
      },
    };
  })());
